"use strict";

// Browser shim
module.exports = function()
{
	return null;
};



//////////////////
// WEBPACK FOOTER
// /~/limited-request-queue/shims/parse-domain.js
// module id = 2170
// module chunks = 0